import { render, staticRenderFns } from "./ItemsNotFound.vue?vue&type=template&id=498b50b1&scoped=true&"
import script from "./ItemsNotFound.vue?vue&type=script&lang=ts&"
export * from "./ItemsNotFound.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498b50b1",
  null
  
)

export default component.exports